import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/dates/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path0/src/components/ClientWrapper/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CookieBanner/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GenerateDictionariesModal"] */ "/vercel/path0/src/components/GenerateDictionnariesButton/GenerateDictionnariesButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NeumoHeader"] */ "/vercel/path0/src/components/SliceMachine/NeumoHeader/NeumoHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyMobileCta"] */ "/vercel/path0/src/components/StickyMobileCta/StickyMobileCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/dictionaries/dictionary-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/vercel/path0/theme.ts");
